import type { IButtonProps, Size } from '@/components/UiButton/UiButton.types'

export enum EMODE_SHOW_ONLY {
  ONLY_PL='pl',
  ALWAYS='always'
}

export interface INavButton extends IButtonProps {
  size: Size;
  label: string;
  showOnly: EMODE_SHOW_ONLY;
  callback?: () => void;
}
